//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import IntSlides from '~/components/IntSlides'
import ProductsCard from '~/components/ProductsCard'
import ModalProducts from '~/components/ModalProducts'
const sortListConst = [
  { short: 'DESC', field: 'id', icon: 'bx-analyse', text: 'Más Recientes' },
  { short: 'DESC', field: 'price', icon: 'bx-sort-up', text: 'Precio más alto' },
  { short: 'ASC', field: 'price', icon: 'bx-sort-down', text: 'Precio más bajo' }
]
export default {
  name: 'ProductsPage',
  components: {
    ProductsCard,
    IntSlides,
    ModalProducts
  },
  async fetch () {
    this.searching = true
    const idCat = this.$route.params.idCat ?? this.filters.category.id
    const category = idCat ? `&categories=[${idCat}]` : ''
    const text = this.filters.text !== '' ? `&search=${this.filters.text}` : ''
    const sort = `&sort=[["${this.filters.sort.field}","${this.filters.sort.short}"]]`
    const page = `page=${this.page.current_page}`
    const perPage = `&per_page=${this.page.per_page}`
    const offer = this.filters.offer === true ? '&offer=true' : ''
    this.products = await this.$axios.get(`/products?active=true&${page}${offer}${perPage}${category}${text}${sort}`).then((res) => {
      // console.log(res.data)
      this.page.last_page = res.data.last_page
      this.searching = false
      return res.data.data
    })
    this.products.forEach((prod) => {
      if (this.checkProd(prod)) {
        this.$store.commit('cart/UPD_PRODUCT_IN_CART', { item: prod })
      }
    })
  },
  data () {
    return {
      timeout: null,
      showSortList: false,
      catList: false,
      loading: false,
      searching: false,
      products: [],
      fakePage: 0,
      page: {
        per_page: 16,
        current_page: 1,
        last_page: 1
      },
      sortList: sortListConst,
      filters: {
        category: {
          id: '',
          name: 'Todas las categorias'
          // video: `${this.$axios.defaults.baseURL}/repositorio/wholesale-videos/artificial-grass.mp4`
        },
        sort: sortListConst[0],
        offer: false,
        text: ''
      },
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ checkProd: 'cart/checkProd', categories: 'categories', findCatById: 'findCatById', findCatByName: 'findCatByName' }),
    pageNumbers () {
      const array = Array.from({ length: this.page.last_page }, (_, i) => i + 1)
      const arrayFilterd = this.page.current_page > this.page.last_page - 3
        ? this.page.current_page === this.page.last_page
          ? array.filter(e => e > this.page.last_page - 5)
          : array.filter(e => e > this.page.last_page - 8)
        : this.page.current_page < 5
          ? array.filter(e => e < 8)
          : array.filter(e => e > this.page.current_page - 3 && e < this.page.current_page + 3)
      const fakeFiltered = array.filter(e => e > this.fakePage - 3 && e < this.fakePage + 3)
      // console.log(arrayFilterd)
      return this.fakePage > 0 ? fakeFiltered : arrayFilterd
    }
  },
  activated () {
    if (this.$fetchState.timestamp <= Date.now() - 180000) {
      this.$fetch()
    }
  },
  created () {
    const params = this.$route.params
    if (this.$route.query.offer || this.$route.params.offer) {
      this.filters.offer = true
    }
    if (this.$route.query.page || this.$route.params.page) {
      this.page.current_page = Number(this.$route.query.page) ?? 1
    }
    if (params.category) {
      const category = !params.idCat ? this.findCatByName(params.category) : isNaN(params.idCat) ? this.findCatByName(params.category) : this.findCatById(params.idCat)
      if (category) {
        this.filters.category.id = category.id
        this.filters.category.name = category.name
      }
      // this.filters.category.video = category.video ? `${this.$axios.defaults.baseURL}/repositorio/wholesale-videos/${category.video}` : null
      // console.log(this.filters.category.video)
    }
    if (params.search) {
      this.filters.text = params.search
    }
  },
  methods: {
    searchProducts () {
      this.loading = true
      if (this.timeout) { clearTimeout(this.timeout) }
      this.timeout = setTimeout(() => {
        this.page.current_page = 1
        this.loading = false
        this.$fetch()
      }, 2000)
    },
    goToPage (page) {
      this.page.current_page = page
      this.$router.replace({ query: { ...this.$route.query, page } })
      this.fakePage = 0
      this.$fetch()
    },
    changeFakePage (type) {
      const page = this.fakePage !== 0 ? this.fakePage : this.page.current_page
      this.fakePage = type
        ? page < this.page.last_page - 4
          ? page + 5
          : page
        : page > 10
          ? page - 5
          : page
    },
    prevPage () {
      this.page.current_page = this.page.current_page <= 1 ? 1 : this.page.current_page - 1
      this.$router.replace({ query: { ...this.$route.query, page: this.page.current_page } })
      this.fakePage = 0
      this.$fetch()
    },
    nextPage () {
      this.page.current_page = this.page.current_page >= this.page.last_page ? this.page.last_page : this.page.current_page + 1
      this.$router.replace({ query: { ...this.$route.query, page: this.page.current_page } })
      this.fakePage = 0
      this.$fetch()
    },
    passURI (uri) {
      return uri.toLowerCase().replace(/ /g, '-')
    }
  },
  head () {
    return {
      title: this.filters.category.name,
      meta: [
        { hid: 'og:title', name: 'og:title', content: this.filters.category.name },
        { hid: 'description', name: 'description', content: this.filters.category.name }
      ]
    }
  }
}
